import addFit from 'widget/utils/helpers/addFit';
import Analytics from 'modules/Analytics/Analytics';
import MoreLink from 'widget/components/MoreLink';
import Row from 'widget/components/Row';
import Rows from 'widget/components/Rows';
import Text from 'widget/components/Text';
import TextHeading from 'widget/components/TextHeading';
import TrackImage from 'widget/components/TrackImage';
import useMount from 'hooks/useMount';
import { useState } from 'react';
import { useTranslate } from 'widget/hooks';

type Props = {
  analytics?: Analytics;
  radioEditMediaServer: string;
  similarArtists: Array<{
    artistId: number;
    name: string;
    image?: string;
  }>;
  similarArtistsUrl: string;
  title: string;
};

function Tracks({
  radioEditMediaServer,
  similarArtists,
  similarArtistsUrl,
}: Props) {
  const [windowRef, setWindowRef] = useState({} as Window);
  const translate = useTranslate();

  useMount(() => setWindowRef(window));

  return (
    <Rows height={windowRef?.innerHeight ?? 0}>
      <Row cursorPointer={false} thinRow>
        <Text>Featured Artists in this playlist</Text>
      </Row>
      {similarArtists.map(({ name: artistName, artistId: id }) => {
        const imageUrl = `${radioEditMediaServer}/v3/catalog/artist/${id}?ops=fit(60%2C60)`;
        return (
          <Row cursorPointer={false} key={id} thinRow>
            {imageUrl && <TrackImage src={addFit(imageUrl)} />}
            <TextHeading>{artistName}</TextHeading>
          </Row>
        );
      })}
      <MoreLink href={similarArtistsUrl} text={translate('View All')} />
    </Rows>
  );
}

export default Tracks;
